import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["StructuredDataFaq"] */ "/app/src/components/tools/StructuredDataFaq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StructuredDataTool"] */ "/app/src/components/tools/StructuredDataTool.tsx");
